
// --- Shipping Protection Add-on (Fixed & Synced Version) --- //

const addonProductHandle = 'vip-toimitusturva'; // change this handle
let userOptedOut = false;
let isProcessing = false;
let observerWatch = null; // ✅ Store observer globally



// 🧩 Get variant ID
async function getVariantIdByHandle(handle) {
  const res = await fetch(`/products/${handle}.js`);
  const product = await res.json();
  return product.variants[0].id;
}

// ➕ Add add-on product
async function addAddon(variantId) {
  if (isProcessing) return;
  isProcessing = true;

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  });

  await refreshCartDrawer();
  isProcessing = false;
}

// ➖ Remove add-on product
async function removeAddon(variantId) {
  const cart = await fetch('/cart.js').then(r => r.json());
  const item = cart.items.find(i => i.variant_id === variantId);
  if (!item) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: item.key, quantity: 0 })
  });

  await refreshCartDrawer();
}

// 🔁 Refresh cart drawer section
async function refreshCartDrawer() {
  try {
    const res = await fetch(window.location.pathname + '?sections=cart-drawer');
    const data = await res.json();

    const newDrawer = document.createElement('div');
    newDrawer.innerHTML = data['cart-drawer'];

    const drawer = document.querySelector('cart-drawer');
    const newContent = newDrawer.querySelector('cart-drawer');
    if (drawer && newContent) drawer.innerHTML = newContent.innerHTML;

    initAddonCheckbox();
    bindOverlayClose();
    // syncCheckboxState();
  } catch (e) {
    console.error('Error refreshing cart:', e);
  }
}

async function syncCheckboxState(forceChecked = null) {
  const checkbox = document.getElementById('addon-checkbox');
  if (!checkbox) return;

  if (forceChecked !== null) {
    checkbox.checked = forceChecked;
    lastCheckboxState = forceChecked; // ✅ Store latest user choice
    return;
  }

  const variantId = await getVariantIdByHandle(addonProductHandle);
  const cart = await fetch('/cart.js').then(r => r.json());
  const hasAddon = cart.items.some(i => i.variant_id === variantId);

  checkbox.checked = hasAddon;
  lastCheckboxState = hasAddon; // ✅ Keep in sync
}

async function handleAddonChange() {
    const checkbox = document.getElementById('addon-checkbox');
    if (!checkbox) return;

    const variantId = await getVariantIdByHandle(addonProductHandle);
    const cart = await fetch('/cart.js').then(r => r.json());
    const hasAddon = cart.items.some(i => i.variant_id === variantId);

    checkbox.disabled = true;
    if (checkbox.checked) {
      userOptedOut = false;
      await addAddon(variantId);
    } else {
      userOptedOut = true;
      await removeAddon(variantId);
    }
    checkbox.disabled = false;
}
// 🧩 Checkbox logic
async function initAddonCheckbox() {
  const checkbox = document.getElementById('addon-checkbox');
  if (!checkbox) return;

  const variantId = await getVariantIdByHandle(addonProductHandle);
  const cart = await fetch('/cart.js').then(r => r.json());
  const hasAddon = cart.items.some(i => i.variant_id === variantId);

  // Match checkbox with cart state
  checkbox.checked = hasAddon;

//   checkbox.addEventListener('change', async () => {
//     checkbox.disabled = true;
//     if (checkbox.checked) {
//       userOptedOut = false;
//       await addAddon(variantId);
//     } else {
//       userOptedOut = true;
//       await removeAddon(variantId);
//     }
//     checkbox.disabled = false;
//   });
}

// 🧠 Watch cart for product additions
async function observeCart() {
  const variantId = await getVariantIdByHandle(addonProductHandle);

  // ✅ Remove previous observer first
  if (observerWatch) {
    observerWatch.disconnect();
    observerWatch = null;
  }

   observerWatch = new MutationObserver(async () => {
    if (isProcessing) return;
    const cart = await fetch('/cart.js').then(r => r.json());
    const hasAddon = cart.items.some(i => i.variant_id === variantId);

    // Auto-add when first product added
    if (cart.items.length > 0 && !hasAddon && !userOptedOut) {
      // await addAddon(variantId);
    }

    // Auto-remove if only add-on remains
    if (cart.item_count === 1 && hasAddon) {
      await removeAddon(variantId);
      document.querySelector('cart-drawer').classList.add('is-empty');
    }

    // Keep checkbox synced
    const checkbox = document.getElementById('addon-checkbox');
    if (checkbox) checkbox.checked = hasAddon;

    //  syncCheckboxState();
  });

  const drawer = document.querySelector('cart-drawer');
  if (drawer) observerWatch.observe(drawer, { childList: true, subtree: true });
}

// 🧱 Fix overlay click to close drawer
function bindOverlayClose() {
  const overlay = document.querySelector('.cart-drawer__overlay');
  const drawer = document.querySelector('cart-drawer');
  if (!overlay || !drawer) return;

  overlay.addEventListener('click', () => {
    drawer.classList.remove('is-open', 'active');
    overlay.classList.remove('is-visible', 'active');
    document.body.classList.remove('overflow-hidden');
  });
}

// 🚀 Initialize everything
document.addEventListener('DOMContentLoaded', () => {
  
  // syncCheckboxState();
  window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      setTimeout(function() {
        initAddonCheckbox();
        observeCart();
        bindOverlayClose();
      },500);
    });
  initAddonCheckbox();
  observeCart();
  bindOverlayClose();
});
